import React, { useRef, useState } from 'react';
import styles from './AdminLoginPage.module.scss';
import logo from 'assets/logo/main_logo.png';
import logo2x from 'assets/logo/main_logo@2x.png';
import logo3x from 'assets/logo/main_logo@3x.png';
import { LoginForm } from './LoginForm';
import { EclipseBackground } from 'UI/elements';
import { app } from 'application';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { AppRoutes } from 'UI/router';
import { toast } from 'react-toastify';

export function AdminLoginPage(): React.ReactElement {
  const _usernameRef = useRef<string>('');
  const _passwordRef = useRef<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate: NavigateFunction = useNavigate();

  const onChangeUsername = (event: React.ChangeEvent<HTMLInputElement>): void => {
    _usernameRef.current = event.target.value;
  };

  const onChangePassword = (event: React.ChangeEvent<HTMLInputElement>): void => {
    _passwordRef.current = event.target.value;
  };

  const onSubmit = async (): Promise<void> => {
    setIsLoading(true);

    try {
      await app().userStore.login(_usernameRef.current, _passwordRef.current);
      navigate(AppRoutes.Dashboard.Home());
    } catch (error) {
      toast.error('Invalid username or password');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.adminLoginPage}>
      <EclipseBackground count={20} />

      <div className={styles.header}>
        <img
          src={logo}
          alt="logo"
          className={styles.logo}
          srcSet={`${logo} 1x, ${logo2x} 2x, ${logo3x} 3x`}
        />
      </div>

      <div className={styles.formContainer}>
        <LoginForm
          isLoading={isLoading}
          onSubmit={onSubmit}
          onChangeUsername={onChangeUsername}
          onChangePassword={onChangePassword}
        />
      </div>
    </div>
  );
}
